import c1 from "assets/img/posts/c1.jpg";
import c2 from "assets/img/posts/c2.jpg";
import c3 from "assets/img/posts/c3.jpg";
import ImagePollItem from "./ImagePollItem";

const PostImagePoll = () => {
    return (
        <div className="post-image-poll-wrapper d-flex flex-j-center flex-a-start gap-5 pt-20 pb-20">
            <ImagePollItem img={c1} percent={25} />
            <ImagePollItem img={c2} percent={35} />
            <ImagePollItem img={c3} percent={40} />
        </div>
    );
};

export default PostImagePoll;
